import masterDto from 'grpc-bob/master_data_pb';

import {MasterClient, getMetadata} from './base';

const MasterService = {
  async getCities(token: string){
    const req = new masterDto.RetrieveProvinceRequest();

    const res = await MasterClient.retrieveProvince(req, getMetadata(token));

    return res.toObject().provincesList;
  },
  async getWards(cityName: string, token: string){
    const req = new masterDto.RetrieveWardRequest();
    req.setCityName(cityName);

    const res = await MasterClient.retrieveWard(req, getMetadata(token));

    return res.toObject().dataMap;
  }
};

export default MasterService